import { render } from "./index.vue?vue&type=template&id=04014a84&scoped=true"
import script from "./radio-button.ts?vue&type=script&lang=js"
export * from "./radio-button.ts?vue&type=script&lang=js"

import "./radio-button.scss?vue&type=style&index=0&id=04014a84&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-04014a84"

export default script